import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import { Badge, IconButton, Typography } from '@mui/material';
import type React from 'react';
import { useCommunicationCount } from '../hooks/useCommunicationCount';
import CommunicationModal from './CommunicationModal';
import { badgeStyle } from '../styles/styles';

const CommunicationIconComponent: React.FC = () => {
  const { count,  anchorEl, handleClick, handleClose, isModalOpen } = useCommunicationCount();

  return (
    <>
      <IconButton
        sx={{ display: 'flex', justifyContent: 'start', gap: 2, '&:hover': {backgroundColor: 'transparent'} }}
        color="inherit"
        onClick={handleClick}
        aria-label="communications"
      >
        <Badge badgeContent={count} color="error" sx={badgeStyle}>
          <MessageOutlinedIcon />
        </Badge>
        <Typography
          sx={{
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        >
          Communications
        </Typography>
      </IconButton>
      {isModalOpen && (
        <CommunicationModal
          open={isModalOpen}
          onClose={handleClose}
          anchorEl={anchorEl as HTMLButtonElement}
        />
      )}
    </>
  );
};

export default CommunicationIconComponent;
